<kal-button [kalTheme]="kalTheme"
            [disabled]="disabled"
            class="gup-C-moreInfos gup-O-link">
    <kal-icon>{{icon}}</kal-icon>
    <span>
        <ng-content></ng-content>
    </span>
</kal-button>
